import {
    getContentTypeLoading,
    getContentTypeSuccess,
    getContentTypeFailure,
    
    getDraftListLoading,
    getDraftListSuccess,
    getDraftListFailure,
  
    getAuthorEmailLoading,
    getAuthorEmailSuccess,
    getAuthorEmailFailure,
  
    getContentTitleLoading,
    getContentTitleSuccess,
    getContentTitleFailure,
  
    getEntityTypeLoading,
    getEntityTypeSuccess,
    getEntityTypeFailure,
  
    getEntityNameLoading,
    getEntityNameSuccess,
    getEntityNameFailure,
  
    getViewDraftsLoading,
    getViewDraftsSuccess,
    getViewDraftsFailure,
  
    getQueueDraftsLoading,
    getQueueDraftsSuccess,
    getQueueDraftsFailure,
  
    getScheduleDraftsLoading,
    getScheduleDraftsSuccess,
    getScheduleDraftsFailure,
  
    putScheduleDraftLoading,
    putScheduleDraftSuccess,
    putScheduleDraftFailure,
  
    getPublishedListLoading,
    getPublishedListSuccess,
    getPublishedListFailure,
  
    getPublisNowLoading,
    getPublisNowSuccess,
    getPublisNowFailure,
  
  } from "../../slices/scheduler";
  import { 
    getSchedulerFilterRepo, 
    getSchedulerListRepo, 
    getSchedulerDraftsRepo, 
    getSchedulerQueueRepo,
    getScheduleDraftRepo,
    putScheduleDraftRepo,
    getPublishedContentRepo,
    getPublishedNowRepo,
   } from '../../repositories/content';
  
  
  //content type
  export const getContentTypeFilter = (params) => {
    return async (dispatch) => {
      dispatch(getContentTypeLoading());
      await getSchedulerFilterRepo(params)
        .then((response) => {
          if (response?.status >= 200 && response?.status <= 300) {
            dispatch(getContentTypeSuccess(response?.data?.data));
          }
        })
        .catch((error) => {
          if (error && error.response) {
            dispatch(getContentTypeFailure(error.message));
          }
        });
    };
  };
  
  //author email
  export const getAuthorEmailFilter = (params) => {
    return async (dispatch) => {
      dispatch(getAuthorEmailLoading());
      await getSchedulerFilterRepo(params)
        .then((response) => {
          if (response?.status >= 200 && response?.status <= 300) {
            dispatch(getAuthorEmailSuccess(response?.data?.data));
          }
        })
        .catch((error) => {
          if (error && error.response) {
            dispatch(getAuthorEmailFailure(error.message));
          }
        });
    };
  };
  
  //content title
  export const getContentTitleFilter = (params) => {
    return async (dispatch) => {
      dispatch(getContentTitleLoading());
      await getSchedulerFilterRepo(params)
        .then((response) => {
          if (response?.status >= 200 && response?.status <= 300) {
            dispatch(getContentTitleSuccess(response?.data?.data));
          }
        })
        .catch((error) => {
          if (error && error.response) {
            dispatch(getContentTitleFailure(error.message));
          }
        });
    };
  };
  
  //entity type
  export const getEntityTypeFilter = (params) => {
    return async (dispatch) => {
      dispatch(getEntityTypeLoading());
      await getSchedulerFilterRepo(params)
        .then((response) => {
          if (response?.status >= 200 && response?.status <= 300) {
            dispatch(getEntityTypeSuccess(response?.data?.data));
          }
        })
        .catch((error) => {
          if (error && error.response) {
            dispatch(getEntityTypeFailure(error.message));
          }
        });
    };
  };
  
  //entity name
  export const getEntityNameFilter = (params) => {
    return async (dispatch) => {
      dispatch(getEntityNameLoading());
      await getSchedulerFilterRepo(params)
        .then((response) => {
          if (response?.status >= 200 && response?.status <= 300) {
            dispatch(getEntityNameSuccess(response?.data?.data));
          }
        })
        .catch((error) => {
          if (error && error.response) {
            dispatch(getEntityNameFailure(error.message));
          }
        });
    };
  };
  
  // Draft List 
  export const getDraftListFilter = (params) => {
    return async (dispatch) => {
      dispatch(getDraftListLoading());
      await getSchedulerListRepo(params)
        .then((response) => {
        if (response?.status >= 200 && response?.status <= 300) {
          dispatch(getDraftListSuccess(response?.data?.data));
        }
        })
        .catch((error) => {
        if (error && error.response) {
              dispatch(getDraftListFailure(error.response?.data?.message));
          }
        });
    };
  };
  
  // View Draft List for specific type
  export const getViewdraftsFilter = (params) => {
    return async (dispatch) => {
      dispatch(getViewDraftsLoading());
      await getSchedulerDraftsRepo(params)
        .then((response) => {
          if (response?.status >= 200 && response?.status <= 300) {
            dispatch(getViewDraftsSuccess(response?.data?.data));
          }
        })
        .catch((error) => {
          if (error && error.response) {
            dispatch(getViewDraftsFailure(error.message));
          }
        });
    };
  };
  
  // Queue Draft List
  export const getScheduledQueueList = (params) => {
    return async (dispatch) => {
      dispatch(getQueueDraftsLoading());
      await getSchedulerQueueRepo(params)
        .then((response) => {
          if (response?.status >= 200 && response?.status <= 300) {
            dispatch(getQueueDraftsSuccess(response?.data?.data));
          }
        })
        .catch((error) => {
          if (error && error.response) {
            dispatch(getQueueDraftsFailure(error.response?.data?.message));
          }
        });
    };
  };
  
  //get schedule draft to publish
  export const getScheduledDraft = (params) => {
    return async (dispatch) => {
      dispatch(getScheduleDraftsLoading());
      await getScheduleDraftRepo(params)
        .then((response) => {
          if (response?.status >= 200 && response?.status <= 300) {
            dispatch(getScheduleDraftsSuccess(response?.data?.data));
          }
        })
        .catch((error) => {
          if (error && error.response) {
            dispatch(getScheduleDraftsFailure(error.message));
          }
        });
    };
  };
  
  //put schedule draft to publish
  export const putScheduledDraft = (params) => {
    return async (dispatch) => {
      dispatch(putScheduleDraftLoading());
      await putScheduleDraftRepo(params)
        .then((response) => {
          if (response?.status >= 200 && response?.status <= 300) {
            dispatch(putScheduleDraftSuccess(response?.data?.data));
          }
        })
        .catch((error) => {
          if (error && error.response) {
            dispatch(putScheduleDraftFailure(error.response?.data));
          }
        });
    };
  };
  
  // published tab=> list data
  export const getPublishedList = (params) => {
    return async (dispatch) => {
      dispatch(getPublishedListLoading());
      await getPublishedContentRepo(params)
        .then((response) => {
          if (response?.status >= 200 && response?.status <= 300) {
            dispatch(getPublishedListSuccess(response?.data?.data));
          }
        })
        .catch((error) => {
          if (error && error.response) {
            dispatch(getPublishedListFailure(error.response?.data?.message));
          }
        });
    };
  };
  
  // publish now
  export const getPublishNow = (params) => {
    return async (dispatch) => {
      dispatch(getPublisNowLoading());
      await getPublishedNowRepo(params)
        .then((response) => {
          if (response?.status >= 200 && response?.status <= 300) {
            dispatch(getPublisNowSuccess(response?.data?.data));
          }
        })
        .catch((error) => {
          if (error && error.response) {
            dispatch(getPublisNowFailure(error.response?.data));
          }
        });
    };
  };